export default function input({ colors, typography, borders }) {
  const { info, inputBorderColor, text } = colors;
  const { size } = typography;
  const { borderWidth } = borders;

  const input = {
    styleOverrides: {
      root: {
        fontSize: size.sm,
        color: text.primary,

        "&:hover:not(.Mui-disabled):before": {
          borderBottom: `${borderWidth[1]} solid ${inputBorderColor}`,
        },

        "&:before": {
          borderColor: inputBorderColor,
        },

        "&:after": {
          borderColor: info.main,
        },
      },
    },
  };

  return input;
}
